<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'permitusers'" [businessName]="vm.businessName"
  [permitNo]="vm.permitNo"></cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>

<div class="container" *ngIf="!vm.isOpening">
  <div class="row ">

    <div class="col-lg-6 mt-2">
      <form>
        <div class="row col mb-3">
          <h4>{{vm.header}}</h4>
        </div>

        <div class="row">
          <div class="mb-2 col-md-6">
            <label for="firstName">First Name</label>
            <input class="form-control" [ngClass]="{'is-invalid': !!error('firstName')}" name="firstName" placeholder=""
              type="text" [(ngModel)]="vm.firstName">
            <div class="invalid-feedback"> {{error('firstName')}} </div>
          </div>

          <div class="mb-2 col-md-6">
            <label for="lastName">Last Name</label>
            <input class="form-control" [ngClass]="{'is-invalid': !!error('lastName')}" name="lastName" placeholder=""
              type="text" [(ngModel)]="vm.lastName">
            <div class="invalid-feedback"> {{error('lastName')}} </div>
          </div>
        </div>

        <div class="row">
          <div class="mb-2 col-md-6">
            <label for="amount">Phone</label>
            <input class="form-control" [ngClass]="{'is-invalid': !!error('userName')}" name="userName" placeholder=""
              type="text" [(ngModel)]="vm.userName">
            <div class="invalid-feedback"> {{error('userName')}} </div>
          </div>
          <div class="mb-2 col-md-6">
            <label for="email">Email</label>
            <input class="form-control" [ngClass]="{'is-invalid': !!error('email')}" name="email" placeholder=""
              type="text" [(ngModel)]="vm.email">
            <div class="invalid-feedback"> {{error('email')}} </div>
          </div>
        </div>

        <div *ngIf="vm.userId == 0">
          <div class="row">
            <div class="mb-2 col-md-6">
              <label for="password">Password</label>
              <input class="form-control" [ngClass]="{'is-invalid': !!error('password')}" name="password" placeholder=""
                type="password" [(ngModel)]="vm.password">
              <div class="invalid-feedback"> {{error('password')}} </div>
            </div>
          </div>
          <div class="row">
            <div class="mb-2 col-md-6">
              <label for="confirmPassword">Confirm Password</label>
              <input class="form-control" [ngClass]="{'is-invalid': !!error('confirmPassword')}" name="confirmPassword"
                placeholder="" type="password" [(ngModel)]="vm.confirmPassword">
              <div class="invalid-feedback"> {{error('confirmPassword')}} </div>
            </div>
          </div>
        </div>

        <div class="row ">
          <div class="col-md-6 mb-2">
            <div class="form-check">
              <label for="isActive" class="form-check-label"> </label>
              <input style="cursor:pointer;" class="form-check-input" name="isActive" type="checkbox" value="true"
                id="defaultCheck1" [(ngModel)]="vm.isActive">

              <span>Active </span>

            </div>
          </div>
        </div>

        <div class="row">
          <div class="col mb-2">
            <div class="d-flex justify-content-end mt-4 ">
              <div class="pr-2">
                <button class="btn btn-block btn-primary" (click)="save()">Save</button>
              </div>
              <div class="pr-2" *ngIf="!vm.isNew">
                <button class="btn btn-block btn-outline-secondary" (click)="setPassword()">Set Password</button>
              </div>
              <div class="pr-2" *ngIf="!vm.isNew">
                <button class="btn btn-block btn-outline-secondary" (click)="delete()">Delete</button>
              </div>

              <div>
                <button class="btn btn-block btn-link" (click)="cancel()">Cancel</button>
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>

</div>

<cli-set-password-modal #setPasswordModal [id]="'setPasswordModal'"></cli-set-password-modal>
<cli-yes-cancel-modal #userDelete [id]="'userDelete'"></cli-yes-cancel-modal>